import { Box, Tab, Tabs } from '@mui/material';
import { useStore } from 'mobx/StoreContext';
import { observer } from 'mobx-react-lite';
import { JobQueueTableType } from 'pages/iPriseV2/common/enum/TeamUserRoles';
import CommonJobQueueTable from 'pages/iPriseV2/common/JobQueueTable';
import React, { useCallback } from 'react';

import ColumnsSidebar from './ColumnsSidebar';

const BenchQueueTable: React.FC = () => {
  const { managementJobQueueService } = useStore();
  const {
    benchSubTab,
    searchTerm,
    selectedTeam,
    selectedSort,
    percentage,
    benchAllJobsPage,
    benchAllJobsRowsPerPage,
    benchMyJobsPage,
    benchMyJobsRowsPerPage,
    benchOverduePage,
    benchOverdueRowsPerPage,
    benchClosedPage,
    benchClosedRowsPerPage,
  } = managementJobQueueService;

  const handleBenchSubTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      managementJobQueueService.setBenchSubTab(newValue);
    },
    [managementJobQueueService],
  );

  return (
    <Box className="table-container-with-sidebar">
      <Box className="table-main-content">
        <Box className="sub-tabs-container">
          <Box className="sub-tabs-wrapper">
            <Tabs
              value={benchSubTab}
              onChange={handleBenchSubTabChange}
              className="sub-tabs"
              variant="scrollable"
              allowScrollButtonsMobile
              TabIndicatorProps={{
                className: 'sub-tab-indicator',
              }}>
              <Tab label="All Jobs" className="sub-tab" />
              <Tab label="My Jobs" className="sub-tab" />
              <Tab label="Overdue" className="sub-tab" />
              <Tab label="Closed" className="sub-tab" />
            </Tabs>
          </Box>
        </Box>

        {benchSubTab === 0 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.MANAGEMENT_BQ_ALL_JOBS}
            status=""
            queryKey="bench-queue-all-jobs"
            page={benchAllJobsPage}
            rowsPerPage={benchAllJobsRowsPerPage}
            onPageChange={(p) =>
              managementJobQueueService.setBenchAllJobsPage(p)
            }
            onRowsPerPageChange={(r) =>
              managementJobQueueService.setBenchAllJobsRowsPerPage(r)
            }
            popperId="skills-popper-bench-all"
            isBenchQueue={true}
            screenStatus=""
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
        {benchSubTab === 1 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.MANAGEMENT_BQ_MY_JOBS}
            status=""
            queryKey="bench-queue-my-jobs"
            page={benchMyJobsPage}
            rowsPerPage={benchMyJobsRowsPerPage}
            onPageChange={(p) =>
              managementJobQueueService.setBenchMyJobsPage(p)
            }
            onRowsPerPageChange={(r) =>
              managementJobQueueService.setBenchMyJobsRowsPerPage(r)
            }
            popperId="skills-popper-bench-my"
            isBenchQueue={true}
            benchStatus="published"
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
        {benchSubTab === 2 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.MANAGEMENT_BQ_OVERDUE}
            status=""
            queryKey="bench-queue-overdue"
            page={benchOverduePage}
            rowsPerPage={benchOverdueRowsPerPage}
            onPageChange={(p) =>
              managementJobQueueService.setBenchOverduePage(p)
            }
            onRowsPerPageChange={(r) =>
              managementJobQueueService.setBenchOverdueRowsPerPage(r)
            }
            popperId="skills-popper-bench-overdue"
            isBenchQueue={true}
            screenStatus="overdue"
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
        {benchSubTab === 3 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.MANAGEMENT_BQ_CLOSED}
            status=""
            queryKey="bench-queue-closed"
            page={benchClosedPage}
            rowsPerPage={benchClosedRowsPerPage}
            onPageChange={(p) =>
              managementJobQueueService.setBenchClosedPage(p)
            }
            onRowsPerPageChange={(r) =>
              managementJobQueueService.setBenchClosedRowsPerPage(r)
            }
            popperId="skills-popper-bench-closed"
            isBenchQueue={true}
            screenStatus="closed"
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
      </Box>
      <ColumnsSidebar />
    </Box>
  );
};

export default observer(BenchQueueTable);
